import React, { useEffect, useState, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../utils/toast";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../authConfig";
import Loading from "../components/material-ui/Loading";
import { callMsGraph } from "../graph";
import { AuthContext } from "../context/Auth/AuthContext";
import loginUser from "../api/login";
import { useRoleContext } from "../context/RolesContext";

const Callback = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const { dispatch } = useContext(AuthContext);
  const redirect = useNavigate();
  const { setRoles } = useRoleContext();

  const handleLogout = async () => {
    dispatch({ type: "LOGOUT" });
    redirect("/login");
    showSuccess("Successfully Logged Out");

    // instance
    //   .logoutPopup()
    //   .then(() => {
    //     dispatch({ type: "LOGOUT" });
    //     redirect("/login");
    //     showSuccess("Successfully Logged Out");
    //   })
    //   .catch((e) => {
    //     console.error(e);
    //   });
  };

  const loginUserFn = async (profile) => {
    const loginData = await loginUser(
      profile.mail,
      profile.displayName,
      profile.id,
      profile.mobilePhone
    );
    if (loginData?.token) {
      // Cookie for viewing the document directly
      document.cookie =
        "skip_login=true; domain=.consumerlaw.com; path=/; secure; SameSite=None";

      setRoles(loginData.user.role_id);
      localStorage.setItem("role_id", loginData.user.role_id);
      dispatch({
        type: "LOGIN",
        payload: {
          // token: loginData.token,
          // userID: loginData?.user?.id,
          // userName: loginData?.name,
          // isAdmin: loginData?.user?.is_admin,

          token: loginData.token,
          id: loginData.user.id,
          user_id: loginData.user.id,
          firstName: loginData.user.first_name,
          lastName: loginData.user.last_name,
          phoneNumber: loginData.user.phonenumber,
          is_admin: loginData.user.is_admin,
          email_id: loginData.user.email,
        },
      });
      showSuccess("Successfully Logged In");
      redirect("/dashboard");
    }
    if (loginData?.code === 401) {
      handleLogout();
    }
  };

  useEffect(() => {
    if (!accounts || accounts.length === 0) {
      redirect("/login");
      return;
    }
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        callMsGraph(response.accessToken).then((response) => {
          setGraphData(response);
          loginUserFn(response);
        });
      })
      .catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
          callMsGraph(response.accessToken).then((response) => {
            setGraphData(response);
          });
        });
      });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        minWidth: "100vw",
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      <Loading />
    </div>
  );
};

export default Callback;
